import { configureStore } from "@reduxjs/toolkit";

import dashboardReducer from "../views/Dashboard/dashboardSlice";
import searchReducer from "../views/SearchBox/searchSlice";
import savedFiltersReducer from "../views/SavedFilters/savedFiltersSlice";
import accountTypesReducer from "../views/AccountTypes/accountTypesSlice";
import usersReducer from "../views/Users/usersSlice";
import labelsReducer from "../views/Users/labelsSlice";
import lastUpdatesReducer from "../views/LastUpdates/lastUpdatesSlice";
import catalogReducer from "../views/Catalog/catalogSlice";
import catalogSearchReducer from "../views/CatalogSearchBox/catalogSearchSlice";
import reportReducer from "../views/Report/reportSlice";

export default configureStore({
  reducer: {
    dashboard: dashboardReducer,
    search: searchReducer,
    savedFilters: savedFiltersReducer,
    accountTypes: accountTypesReducer,
    users: usersReducer,
    labels: labelsReducer,
    lastUpdates: lastUpdatesReducer,
    catalog: catalogReducer,
    catalogSearch: catalogSearchReducer,
    report: reportReducer
  },
});
